  <div *ngIf="community; else elseBlock"
    class="community-list-container cursor-pointer"
    [class]="!cardView ? 'bg-white px-3 d-flex justify-content-between align-items-center py-1 my-2' : 'card-view bg-white p-4'"
    [id]="'COMMUNITY-' + community?.da_id"  (click)="goToCommunityDetail(community)"
    >
    <div class="cursor-pointer"
      [class]="!cardView ? 'd-flex' : 'text-center'"
      (click)="goToCommunityDetail(community)">
      <div class="flex-shrink-0">
        <img class="rounded-corners-8 bg-pic" [src]="community?.media_list[0]?.media_url"
          onerror="this.src='assets/themes/icons/banner-placeholder.svg'"
          alt="banner" [ngClass]="{'mb-3': cardView}"/>
      </div>
      <div [class]="!cardView ? 'ml-3 align-self-center' : 'text-center'">
        <div [class]="!cardView ? 'd-flex' : ''">
          <p [class]="!cardView ? 'heading-4 text-break' : 'heading-4 title mb-2'" [id]="'COMMUNITY-TITLE-' + community?.da_id">{{community.title}}</p>
          <span *ngIf="community?.flags?.is_community_creator === numbers.ONE || community?.member_type === adminMemberType" class="ml-2">
            <div class="custom-tooltip top">
              <span class="tooltip-content text-center">{{translations.key11}}</span>
              <img width="24px" src="assets/themes/icons/community-admin.svg" alt="community admin icon" class="mr-1" (click)="showTooltip($event)"/>
            </div>
          </span>
        </div>
        <ng-container *ngIf="!cardView">
          <div class="secondary-paragraph">
            <span class="color-grey-500" [id]="'COMMUNITY-CREATED-BY-' + community?.da_id">
              {{translations.key1}}
              <span *ngIf="(community.created_by.custom_id === userId) else createdBy;">{{translations.key12}}</span>
              <ng-template #createdBy>
                {{community.created_by.full_name}}
              </ng-template>
            </span>
          </div>
        </ng-container>
        <div [class]="!cardView ? 'd-flex' : ''" class="secondary-paragraph mt-3">
          <span *ngIf="community?.flags?.is_past_community !== pastCommunityType" class="color-grey-700">
            <ng-container *ngIf="community && community.members">
              <span *ngIf="!cardView" class="mr-1 align-self-center flex-shrink-0">
                {{community.members.count}} {{community.members.text}}
              </span>
            </ng-container>
          </span>
          <ng-container *ngIf="cardView">
            <div [ngClass]="{'community-by secondary-paragraph': cardView}">
              <span class="color-grey-500">{{translations.key1}}
              <span *ngIf="(community.created_by.custom_id === userId) else createdBy;">{{translations.key12}}</span></span>
              <ng-template #createdBy>
                {{community.created_by.full_name}}
              </ng-template>
            </div>
          </ng-container>
          
          <ng-container *ngIf="(community?.flags?.is_past_community !== pastCommunityType) && community && community?.members">
            <span [class]="!cardView ? 'd-block margin-x-12px slash-grey-500 align-self-center' : 'd-none'"></span>
          </ng-container>
          <div [class]="!cardView ? 'custom-tooltip bottom' : 'd-none' ">
              <span class="tooltip-content text-center" #tooltipText>{{mls.languageText.community.key66}}</span>  
          <img *ngIf="community.privacy === communityPrivacy.PUBLIC" class="privacy-icon"  src="assets/themes/icons/public-community-icon.svg" alt="public-icon">
        </div> 
        <div class="custom-tooltip bottom">
          <span class="tooltip-content text-center" #tooltipText>{{mls.languageText.community.key67}}</span>
            <img class="mb-1" height="18px" *ngIf="community.privacy === communityPrivacy.PRIVATE"  src="assets/themes/icons/private-community-icon.svg" alt="private-icon">
        </div>
        </div>
      </div>
    </div>
    <div *ngIf="showJoinButton"
      class="btn-design request-btn h-auto"
      [ngClass]="fcs.device_detail.is_mobile ? 'small' : 'medium'"
      [class]="withdrawRequest || community?.request?.response === numbers.TWO ? 'outline' : (community?.flags?.is_active !== isCommunityActive? 'outline-disabled disabled' :'outline')"
      (click)="joinCommunity()">
      <img src="assets/themes/images/img-video-loader.gif" height="40"
          class="cursor-pointer loader"
          *ngIf="loader"
          alt="loader"/>
          {{cardActionText}}
    </div>
    <div *ngIf="(community?.member_type == adminMemberType)"  (click)="fcs.stopEventPropagation();" ngbDropdown [id]="'COMMUNITY-EDIT-DROPDOWN-' + community?.da_id">
      <a class="cursor-pointer" id="community" ngbDropdownToggle>
        <img src="assets/themes/icons/kabab-menu-icon.svg" class="pr-3" alt=" menu icon" />
      </a>
  
      <div ngbDropdownMenu aria-labelledby="community" class="ngb-dropdown-list">
        <div class="text-left paragraph pl-0 list-hover p-2 w-100" (click)="edit(community)" [id]="'COMMUNITY-EDIT-BUTTON-' + community?.da_id">
          {{translations.key2}}
        </div>
      </div>
    </div>
  </div>
  <ng-template #elseBlock>
    <div
      class="d-flex flex-column align-items-center justify-content-center h-100 text-center mt-4">
      <img src="assets/themes/images/community-no-data.svg" alt="no community data" />
      <p class="pt-4 w-75 paragraph">
        {{translations.key6}}
      </p>
    </div>
  </ng-template>